<absence-cost-component [props]="props()"></absence-cost-component>
